export { default } from './NewNoteMenu';
